// Vendors
import {
  TrackingEventsEnumeration,
  TrackingLinkEventReturnType,
  TrackingViewEventReturnType,
} from '@gruposantander/opbpay-ui-core-models';
// Constants
import {
  ERROR_MODAL_COMPONENT,
  ERROR_MODAL_EVENT_ACTION,
} from './constants/error.tracking.handlers.constants';
// Enumerations
import { AppErrorEnumeration } from 'enumerations/app-error.enumeration';
// Event Handlers
import { getTrackingViewFromError } from './utils/error.handlers.utils';
// Types
import { ErrorTrackingHandlersReturnType } from './types/error.tracking.handlers.type';
import { TrackBuilderType } from 'types/track-builder.type';

const trackEnterErrorView = (error: AppErrorEnumeration): TrackingViewEventReturnType => ({
  payload: {
    pageName: `/error/${getTrackingViewFromError(error)}`,
    sectionFamily: 'customer',
    sectionCategory: 'orders',
    sectionName: 'lending',
    interactionType: 'page',
    serviceType: 'userSettings',
    errorCategory: getTrackingViewFromError(error),
    errorDescription: error,
  },
  type: TrackingEventsEnumeration.VIEW,
});

const trackCancelApplicationError = (): TrackingLinkEventReturnType => ({
  payload: {
    action: 'exit',
    format: 'link',
    component: 'emptyStates',
    element: 'cancelApplication',
    eventAction: 'clickLink',
    eventLabel: 'cancelApplicationLink',
  },
  type: TrackingEventsEnumeration.LINK,
});

const trackErrorRetry = (): TrackingLinkEventReturnType => ({
  payload: {
    action: 'click',
    format: 'button',
    component: 'emptyStates',
    element: 'tryAgain',
    eventAction: 'clickButton',
    eventLabel: 'tryAgainButton',
  },
  type: TrackingEventsEnumeration.LINK,
});

const trackCloseIconErrorModal = (): TrackingLinkEventReturnType => ({
  payload: {
    action: 'close',
    format: 'cross',
    component: ERROR_MODAL_COMPONENT,
    element: 'cross',
    eventAction: ERROR_MODAL_EVENT_ACTION,
    eventLabel: 'close',
  },
  type: TrackingEventsEnumeration.LINK,
});

const trackCancelButtonErrorModal = (): TrackingLinkEventReturnType => ({
  payload: {
    action: 'cancel',
    format: 'link',
    component: ERROR_MODAL_COMPONENT,
    element: 'cancel',
    eventAction: ERROR_MODAL_EVENT_ACTION,
    eventLabel: 'cancelLink',
  },
  type: TrackingEventsEnumeration.LINK,
});

const trackOpenErrorModal = (): TrackingLinkEventReturnType => ({
  payload: {
    action: 'open',
    format: 'modal',
    component: ERROR_MODAL_COMPONENT,
    element: 'full',
    eventAction: ERROR_MODAL_EVENT_ACTION,
    eventCategory: 'layoutCancelModal',
    eventLabel: 'open',
  },
  type: TrackingEventsEnumeration.LINK,
});

const ErrorTrackingHandlers = (track: TrackBuilderType): ErrorTrackingHandlersReturnType => ({
  handleTrackCancelApplicationError: () => track(trackCancelApplicationError()),
  handleTrackCancelButtonErrorModal: () => track(trackCancelButtonErrorModal()),
  handleTrackCloseIconErrorModal: () => track(trackCloseIconErrorModal()),
  handleTrackEnterErrorView: (error: AppErrorEnumeration) => track(trackEnterErrorView(error)),
  handleTrackErrorRetry: () => track(trackErrorRetry()),
  handleTrackOpenErrorModal: () => track(trackOpenErrorModal()),
});

export { ErrorTrackingHandlers };
